import React from 'react';
import classNames from 'classnames';
import BulmaButton from 'react-bulma-components/lib/components/button';
import Icon from '@mdi/react';

import './style.scss';

const Button = ({
  color,
  onClick,
  children,
  outlined = false,
  remove = false,
  ...props
}) => (
  <BulmaButton
    color={color}
    onClick={onClick}
    outlined={outlined}
    remove={remove}
    {...props}
  >
    {children}
  </BulmaButton>
);

export const IconButton = ({ path, type, size = 1, className, ...props }) => (
  <button
    className={classNames(className, {
      'icon-btn': true,
      [`icon-btn--${type}`]: type,
    })}
    type="button"
    tabIndex="0"
    {...props}
  >
    <Icon path={path} size={size} />
  </button>
);

export const ButtonGroup = ({ props, children }) => (
  <BulmaButton.Group {...props}>{children}</BulmaButton.Group>
);

export default Button;
